import React from "react";
import { MaskedHeading, Fade } from "@/components/Reveal";

// Editorial page hero with image + masked title.
export default function PageHero({ eyebrow, titleLines = [], image, kicker }) {
  return (
    <section className="relative h-[75svh] min-h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt={titleLines.join(" ")} className="img-cover" />
      </div>
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      <div className="relative h-full mx-auto max-w-[1600px] px-6 md:px-12 flex flex-col justify-end pt-28 pb-16 md:pb-20">
        <Fade delay={0.15}>
          <p className="text-white/80 text-xs uppercase tracking-label mb-6">{eyebrow}</p>
        </Fade>
        <h1 className="font-display text-white font-light leading-[1.0] text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[5.5rem] tracking-tight max-w-[22ch]">
          <MaskedHeading lines={titleLines} delay={0.3} />
        </h1>
        {kicker && (
          <Fade delay={0.9}>
            <p className="mt-8 text-white/85 font-light text-lg max-w-2xl">{kicker}</p>
          </Fade>
        )}
      </div>
    </section>
  );
}
